import { CommunityGuidelinesContent } from '../features/support/CommunityGuidelinesContent';

export function CommunityGuidelines() {
  return <CommunityGuidelinesContent />;
}
